'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notFound = require('./not-found');

var _notFound2 = _interopRequireDefault(_notFound);

var _notAuthorized = require('./not-authorized');

var _notAuthorized2 = _interopRequireDefault(_notAuthorized);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = angular.module('ifeis.routes.errors', ['ifeis.routes.errors.not-found', 'ifeis.routes.errors.not-authorized']);


//////////////////
// WEBPACK FOOTER
// ./routes/errors/index.js
// module id = 532
// module chunks = 0